export default "__VITE_ASSET__f95b7127__"